import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";

import { CircularProgress } from "@mui/material";
import {
  customerservice,
  loanManagementUrl,
  setupManagementUrl,
} from "../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
  fetchJson,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { tokens } from "../../../theme";
import { useTheme } from "@emotion/react";

const RebookGroupLoan = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  // const customersData = [
  //   { id: '36991073', name: 'Lilian Kilani', email: 'fulusi@gmail.com', phone: '0798706353', branch: 'Kitengela', loanLimit: 3000, createdAt: 'Nov 29, 2021' },
  //   // Add more customer data as needed
  // ];
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState(null);
  const [amount, setAmount] = useState("");
  const [loanProductSelected, setLoanProductSelected] = useState([]);
  const [loanProduct, setLoanProduct] = useState("");
  const [customers, setCustomers] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const resetForm = () => {
    setSearchTerm("");
    setFilteredCustomer(null);
    setAmount("");
    setLoanProductSelected("");
  };

  const handlesearch = async () => {
    setLoadingSearch(true); // Start loading

    try {
      const mutationdata = { searchParameter: searchTerm };

      // Perform API call to search customer
      const customer = await fetchJson({
        objectName: "searchGroupForLoanRebooking",
        inputObjectName: "searchGroupforLoanRebooking",
        params: mutationdata,
        baseUrl: customerservice.uri,
      });

      if (JSON.parse(customer.results) === null) {
        Swal.fire("Sorry!", "Group Loan Not found", "warning");
      }
      setFilteredCustomer(JSON.parse(customer.results) || null); // Update state with customer data
    } catch (error) {
      console.error("Search error:", error);
      Swal.fire(
        "Search Failed",
        "An error occurred during the search. Please try again later.",
        "error"
      );
    } finally {
      setLoadingSearch(false); // End loading after search is completed
    }
  }; // Short debounce delay for a smoother typing experience

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    setFilteredCustomer(null);

    if (searchTerm.length >= 3) {
      const delaySearch = setTimeout(() => {
        handlesearch(searchTerm);
      }, 50); // Delay search by 10ms

      return () => clearTimeout(delaySearch);
    }
  }, [searchTerm]);

  useEffect(() => {
    const fetchData = async () => {
      const params = { companyId: companyId };
      const productResponse = await fetchJsonDynamic(
        "groupProducts",
        "parameters",
        params,
        setupManagementUrl.uri
      );
      const allProducts = JSON.parse(productResponse.results) || [];

      setLoanProduct(allProducts);
    };
    fetchData();
  }, []);
  const handleAppraisalSubmit = async () => {
    setLoadingSubmit(true); // Start loading when the form is submitted

    try {
      const mutationData = {
        p_groupId: filteredCustomer.group_id,
        // p_principle: parseInt(amount),
        p_productid: loanProductSelected,
        p_companyid: companyId,
      };

      const response = await executeAnyMutation(
        "rebookGroupLoan",
        mutationData,
        "loanRebooking",
        false,
        loanManagementUrl.uri
      );
      const parsedResults = JSON.parse(response.results);
      if (parsedResults.LoanId !== null) {
        if (parsedResults > 0) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Loan Re-booked Successfully!",
          });
          // Reset form upon successful submission
          await handlesearch();
        } else if (parsedResults === -33) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "Deposit for this loan is required!",
          });
          // Reset form upon successful submission
        } else if (parsedResults === -63) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "The chosen Product has no charges!",
          });
        } else if (parsedResults === -10) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "Group has an Existing Loan!",
          });
          // Reset form upon successful submission
        } else if (parsedResults === -62) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "The chosen Group has no Members!",
          });
          // Reset form upon successful submission
        } else if (parsedResults === -50) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "Principle Applied is not within Product Loan Range!",
          });
        } else if (parsedResults === -31) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: "Loan Rebooked More than 3 times!",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Unsuccessful Group Loan Rebooking!",
            text: parsedResults,
          });
        }
      } else if (response.errors) {
        throw new Error(
          response.errors[0].Error || "An internal server error occurred."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
      resetForm();
    } finally {
      setLoadingSubmit(false); // End loading after the process
    }
  };
  const date = new Date();
  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5">Re-Book Group Loan</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <TextField
            label="Search Group Loan by group phone number | Group Code | Group Name"
            placeholder="Enter search criteria"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: loadingSearch && (
                <CircularProgress size={24} sx={{ marginRight: 2 }} />
              ),
            }}
          />
        </Grid>
        {/* <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handlesearch}
            disabled={loadingSearch}
          >
            Search
          </Button>
        </Grid> */}
      </Grid>

      {filteredCustomer && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[200]}` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Customer Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Group Name:</strong> {filteredCustomer.group_name}
                  </Typography>
                  <Typography>
                    <strong>Mobile Number:</strong>{" "}
                    {filteredCustomer.mobile_number}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Branch:</strong> {filteredCustomer.branch_name}
                  </Typography>
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {filteredCustomer.date_created
                      ? formatter.format(
                          new Date(filteredCustomer.date_created)
                        ) // Format the date
                      : "N/A"}
                  </Typography>
                  <Typography>
                    <strong>Current Loan Limit:</strong>{" "}
                    {filteredCustomer.loan_limit || "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[200]}` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Old Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Loan Product:</strong>{" "}
                    {filteredCustomer.product_name || "N/A"}
                  </Typography>
                  <Typography>
                    <strong>Amount To Disburse:</strong>{" "}
                    {filteredCustomer.amount_to_disburse}
                  </Typography>
                  {/* <Typography>
                    <strong>Loan Amount:</strong> {filteredCustomer.loan_amount}
                  </Typography> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Loan Balance:</strong>{" "}
                    {filteredCustomer.loan_balance.toLocaleString()}
                  </Typography>
                  <Typography>
                    <strong>Borrow Date:</strong>{" "}
                    {filteredCustomer.borrow_date
                      ? formatter.format(new Date(filteredCustomer.borrow_date)) // Format the date
                      : "N/A"}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ bgcolor: `${colors.primary[200]}` }}>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Loan Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Loan Product</InputLabel>
                    <Select
                      value={loanProductSelected}
                      onChange={(e) => setLoanProductSelected(e.target.value)}
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>
                        Select Loan Product
                      </MenuItem>
                      {loanProduct.map((company) => (
                        <MenuItem key={company.Id} value={company.Id}>
                          {company.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Amount to Disburse"
                    placeholder="Enter Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid> */}
              </Grid>
            </CardContent>
          </Card>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAppraisalSubmit}
            disabled={loadingSubmit} // Disable button when loading
          >
            {loadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit For Appraisal"
            )}
          </Button>
        </>
      )}
    </Box>
  );
};

export default RebookGroupLoan;
